import React from 'react'
import { Loading } from '@shared/components/loading'
import { Input } from '@shared/components/text-field/input'
import { onlyNumInputValueTransformer } from '@shared/components/text-field/value-transformers'
import cx from 'classnames'

import { BrokerSignContentWrapper } from '../content-wrapper'

import { ViewProps } from './model'

import styles from './style.module.scss'

export const View = ({
	phone,
	isResendDisabled,
	title,
	isLoading,
	codeLength,
	onResendCode,
	onChangeCode,
	code,
	errorText,
	timer,
	isConfigLoading,
}: ViewProps) => (
	<BrokerSignContentWrapper title={title}>
		<div className={styles.phoneInfo}>Отправили код в СМС на номер {phone}</div>
		<div className={styles.inputWrapper}>
			<Input
				value={code}
				name='sms_code'
				label='Код из смс'
				className={styles.input}
				disabled={isLoading || isConfigLoading}
				transformValue={onlyNumInputValueTransformer}
				maxLength={codeLength}
				onChange={onChangeCode}
				error={errorText ?? false}
			/>
			{isConfigLoading && <Loading min className={styles.loaderWrapper} />}
		</div>
		<div
			className={cx(styles.resendCode, (isResendDisabled || isLoading) && styles.disabled)}
			onClick={onResendCode}
		>
			{isResendDisabled ? <>Отправить код повторно через {timer} </> : 'Отправить код повторно'}
		</div>
	</BrokerSignContentWrapper>
)
